import React, { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';

import { Button } from 'components';
import { PageTitle } from 'pages/Layout/PageTitle';
import { providerService } from 'services/providers';

import { downloadcsv } from '../../../helpers/downloadcsv';

export const StockReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const now = new Date();

  const handleDownloadStockReport = async () => {
    setIsLoading(true);
    toast.info('Aguardando relatório');

    try {
      const { data } = await providerService.getStockReport();
      downloadcsv('ingenico_estoque', data);
      toast.success('Relatório Gerado com sucesso');
    } catch (error) {
      console.error(error);
      toast.error('Falha ao gerar relatório');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadStockReportCMP = async () => {
    setIsLoading(true);
    toast.info('Aguardando relatório');

    try {
      const { data } = await providerService.getStockReportCMP();
      downloadcsv('ingenico_estoque_cmp', data);
      toast.success('Relatório Gerado com sucesso');
    } catch (error) {
      console.error(error);
      toast.error('Falha ao gerar relatório');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <>
        <PageTitle>Relatório de Estoque</PageTitle>

        <Grid container spacing={2}>
          <Grid item xs={12} lg={3}>
            <Button loading={isLoading} fullWidth onClick={handleDownloadStockReport}>
              Exportar relatório - Estoque
            </Button>
          </Grid>
        </Grid>

        <div style={{ marginTop: 32 }}>
          <PageTitle>Relatório de Estoque - CMP</PageTitle>

          <Grid container spacing={2}>
            <Grid item xs={12} lg={3}>
              <Button loading={isLoading} fullWidth onClick={handleDownloadStockReportCMP}>
                Exportar relatório - CMP
              </Button>
            </Grid>
          </Grid>
        </div>
      </>
    </>
  );
};
